
import { useState } from 'react';
import BookingModal from './BookingModal';

export default function ServicesSection() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  const services = [
    {
      name: 'Svédmasszázs',
      description: 'Teljes test, hát vagy derék masszázs',
      details: 'Klasszikus svédmasszázs technikával, amely segít a feszültség oldásában és a vérkeringés javításában.',
      image: 'https://static.readdy.ai/image/5f12d79e9d850055a25ce719729b8deb/15aa5271317a64f120ae60b94df28d00.jpeg'
    },
    {
      name: 'Relaxációs masszázs',
      description: 'Teljes kikapcsolódás és feltöltődés',
      details: 'Lassú, nyugtató mozdulatokkal végzett masszázs, amely segít a stressz levezetésében és a belső béke megtalálásában.',
      image: 'https://static.readdy.ai/image/5f12d79e9d850055a25ce719729b8deb/8e77b9ccd512826941374170aed55f8e.jpeg'
    },
    {
      name: 'Stresszoldó masszázs',
      description: 'A mindennapi feszültség oldására',
      details: 'Speciálisan a stressz okozta izomfeszültség oldására kifejlesztett technikák alkalmazása a teljes test harmonizálásáért.',
      image: 'https://static.readdy.ai/image/5f12d79e9d850055a25ce719729b8deb/64c4f6cf66abb409f73f88133244d356.jpeg'
    }
  ];

  return (
    <>
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-stone-800 mb-6">
                Mit nyújtok
              </h2>
              <p className="text-xl text-stone-600 max-w-3xl mx-auto leading-relaxed">
                A kezelés minden esetben egyedi igény alapján történik. Nincs két egyforma ember. 
                Minden vendég más feszültséget hord, más terhelést kap a mindennapokban.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <div key={index} className="bg-stone-50 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                  <img
                    src={service.image}
                    alt={service.name}
                    className="w-full h-48 object-cover object-top"
                  />
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-stone-800 mb-3">
                      {service.name}
                    </h3>
                    <p className="text-amber-700 font-medium mb-3">
                      {service.description}
                    </p>
                    <p className="text-stone-600 mb-6 leading-relaxed">
                      {service.details}
                    </p>
                    <a
                      href="https://app.minup.io/book/zoltan-grendorf/category/67f7bc13-1ad6-40f0-addc-782133eed473"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block w-full bg-amber-600 hover:bg-amber-700 text-white py-3 rounded-lg font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer text-center"
                    >
                      <i className="ri-calendar-line mr-2"></i>
                      Foglalás
                    </a>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-12 bg-amber-50 p-8 rounded-lg border-l-4 border-amber-500">
              <h3 className="text-xl font-semibold text-stone-800 mb-4">
                Árak és időtartamok
              </h3>
              <div className="grid md:grid-cols-3 gap-6 text-center">
                <div className="bg-white p-4 rounded-lg shadow">
                  <div className="text-2xl font-bold text-amber-700">30 perc</div>
                  <div className="text-lg text-stone-600">5.000 Ft</div>
                </div>
                <div className="bg-white p-4 rounded-lg shadow">
                  <div className="text-2xl font-bold text-amber-700">60 perc</div>
                  <div className="text-lg text-stone-600">10.000 Ft</div>
                </div>
                <div className="bg-white p-4 rounded-lg shadow">
                  <div className="text-2xl font-bold text-amber-700">90 perc</div>
                  <div className="text-lg text-stone-600">15.000 Ft</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BookingModal isOpen={isBookingOpen} onClose={() => setIsBookingOpen(false)} />
    </>
  );
}
